import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
/**
 * 网站入口
 */
export class AppComponent implements OnInit {
    routerArray: Array<{ name: string, path: string }>;
    COPYRIGHT = '2006-2020';
    RECORDED_CODE = '11010802032834';
    ICP_CODE = '06042528';

    constructor(public httpClient: HttpClient, public router: Router) {
    }

    ngOnInit(): void {
        this.loadConfig();
        this.routerArray = [
            {name: '首页', path: '/main'},
            {name: '产品', path: '/product'},
            {name: '服务', path: '/service'},
            {name: '解决方案', path: '/solution'},
            {name: '关于我们', path: '/about'},
            {name: '招贤纳士', path: '/recruit'},
            {name: '联系我们', path: '/contact'},
        ];
    }

    openWindow1(){
        window.open(`https://beian.miit.gov.cn/`, '_blank');
    }

    openWindow2() {
        window.open(`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${this.RECORDED_CODE}`, '_blank');
    }

    loadConfig() {
        this.httpClient.get('assets/config.json').toPromise().then((res: any) => {
            this.COPYRIGHT = res.copyright || this.COPYRIGHT;
            this.RECORDED_CODE = res.recorded_code || this.RECORDED_CODE;
            this.ICP_CODE = res.icp_code || this.ICP_CODE;
        });
    }
}
